import api from "@/api";
import {
  GET_CATEGORIES,
  SHOW_IMAGE_VIEWER,
  HIDE_IMAGE_VIEWER,
  SET_IMAGE_VIEWER_DATA,
} from './types';

export default {
  [GET_CATEGORIES]: async ({ commit }) => {

    const resp = await api.user.getCategories();

    commit(GET_CATEGORIES, resp.data);
    return resp.data;
  },

  [SET_IMAGE_VIEWER_DATA]: ({ commit }, data) => {
    commit(SET_IMAGE_VIEWER_DATA, data);
  },

  [SHOW_IMAGE_VIEWER]: ({ commit }) => {
    commit(SHOW_IMAGE_VIEWER);
  },

  [HIDE_IMAGE_VIEWER]: ({ commit }) => {
    commit(HIDE_IMAGE_VIEWER);
  },
};
